module.exports = __webpack_public_path__ + "media/img/pages/companies/t-systems-77f2fb93eb58a71e37c7d1f3771a209b.png";